<template>
  <div
    class="flex flex-row align-self-center alert"
    role="alert"
    :class="typeCss"
  >
    <div class="flex items-center icon-big mr-3">
      <i :class="iconCss" />
    </div>

    <div class="flex-row items-center">
      <div class="header mb-5">
        <b><slot name="header" /></b>
      </div>

      <div class="content">
        <slot />
      </div>

      <div class="footer mt-5">
        <b><small><slot name="footer" /></small></b>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Alert",
  props: {
    icon: {
      type: String,
      default: "fas fa-exclamation-circle"
    },
    spin: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "warning"
    }
  },
  data() {
    return {};
  },
  computed: {
    typeCss() {
      return `alert-${this.type}`;
    },
    iconCss() {
      let icon = `fa-fw ${this.icon}`;
      if (this.spin) {
        return `${icon} fa-spin`;
      }
      return `${icon}`;
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.alert {
  font-size: 1.1em;
  padding: 15px;
  margin-bottom: 20px;
}

.alert .icon-big {
  margin-right: 8px;
  font-size: 2.5em;
}
</style>
